import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {hasOfferActivePromotions} from "../../offer/utils/has_offer_active_promotions";
import {hasOfferNoContributionPromotion} from "../../offer/utils/has_offer_no_contribution_promotion";
import {isOfferPreSale} from "../../offer/utils/is_offer_pre_sale";

/**
 * Text of the badge shown on the offer tile (`OfferBoxTopSectionSlider.getOfferBoxBadge`) — same
 * conditions and priority order, so the tracked value always matches what the user sees.
 * `isArchived`/`isUnavailable` are intentionally omitted: they're external props set only by
 * `ArchivedOffersListing`, which isn't wired to this tracking, so they're never true here.
 */
export const getAmplitudeOfferPromotionLocation = (offer: IOfferBoxOffer): string | null => {
    if (hasOfferNoContributionPromotion(offer)) {
        return "Bez wkładu własnego";
    }

    if (hasOfferActivePromotions(offer)) {
        return "Promocje";
    }

    if (isOfferPreSale(offer)) {
        return "Przedsprzedaż";
    }

    return null;
};
import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {hasOfferActivePromotions} from "../../offer/utils/has_offer_active_promotions";
import {hasOfferNoContributionPromotion} from "../../offer/utils/has_offer_no_contribution_promotion";
import {isOfferPreSale} from "../../offer/utils/is_offer_pre_sale";

/**
 * Text of the badge shown on the offer tile (`OfferBoxTopSectionSlider.getOfferBoxBadge`) — same
 * conditions and priority order, so the tracked value always matches what the user sees.
 * `isArchived`/`isUnavailable` are intentionally omitted: they're external props set only by
 * `ArchivedOffersListing`, which isn't wired to this tracking, so they're never true here.
 */
export const getAmplitudeOfferPromotionLocation = (offer: IOfferBoxOffer): string | null => {
    if (hasOfferNoContributionPromotion(offer)) {
        return "Bez wkładu własnego";
    }

    if (hasOfferActivePromotions(offer)) {
        return "Promocje";
    }

    if (isOfferPreSale(offer)) {
        return "Przedsprzedaż";
    }

    return null;
};
